import { useState } from 'react';

import { hasValue } from 'utils/hasValue';

import { useGetCryptoBigedirectToken } from 'api';

import { useOrganisationId, useVirtualAccounts } from 'hooks/context';

import { Spinner } from '@atoms/Spinner/Spinner';

import { BigedirectCryptoIframe } from './BigedirectCryptoIframe';

import { CryptoFundingAccountLayout } from '../CryptoFundingAccountLayout';
import { CryptoFundingEmptyStateContainer } from '../CryptoFundingEmptyStateContainer';

export const BigedirectCryptoFundingContent = () => {
  const organisationId = useOrganisationId<number>();
  const [accountNumber, setAccountNumber] = useState<string>();
  const { accounts } = useVirtualAccounts();

  const { data: { data: bigedirectToken } = {}, isSuccess: isTokenSuccess } =
    useGetCryptoBigedirectToken(
      organisationId,
      { virtual_account_number: accountNumber! },
      {
        query: { enabled: hasValue(accountNumber) }
      }
    );

  if (!accounts.length) {
    return <Spinner />;
  }

  return (
    <CryptoFundingAccountLayout
      accounts={accounts}
      setAccountNumber={setAccountNumber}
    >
      {isTokenSuccess && hasValue(accountNumber) && bigedirectToken ? (
        <div key={accountNumber} className="flex w-full">
          <BigedirectCryptoIframe token={bigedirectToken} />
        </div>
      ) : (
        <CryptoFundingEmptyStateContainer className="h-80 w-full" />
      )}
    </CryptoFundingAccountLayout>
  );
};
